<script>
	import { onDestroy } from 'svelte';
	import { dataStore } from '../lib/store';
	import Icon from './General/Icon.svelte';
  import { translate } from '../lib/translate';

	export let loading;
	let currPage;
	let pages;

	const unsubscribe = dataStore.subscribe(data => {
		if (data.totalCount) {
			pages = calculatePageCount(data.totalCount, data.perPage);
		}

		currPage = data.page;
	});

	function calculatePageCount(total, perPage) {
		let count = Math.ceil(total / perPage);

		if (count < 1) count = 1;

		return count;
	}

	function setPage(cb) {
		dataStore.update(data => ({
			...data,
			page: cb(data.page)
		}));
	}

	function prevPage() {
		if ($dataStore.page > 1) {
			setPage(n => n - 1);
		}
	}

	function nextPage() {
		if ($dataStore.page < pages) {
			setPage(n => n + 1);
		}
	}

	function onChange(e) {
		dataStore.update(store => ({
			...store,
			page: Math.min(Math.max(parseInt(e.target.value), 1), pages)
		}));
	}

	onDestroy(unsubscribe);
</script>

{#if !!pages}
	<div class="pagination" class:disabled={loading}>
		{#if $dataStore.page > 1}
			<div class="page-btn prev" on:click={prevPage}>
				<Icon
					name="ARROW_RIGHT"
					color="#161B45"
					size={12}
					rotate={180}
				/>
			</div>
		{/if}
		<div class="page-btn curr">
			<input
				type="text"
				pattern="[0-9]+"
				bind:value={currPage}
				on:change={e => onChange(e)}
			/>
		</div>
		{#if $dataStore.page < pages}
			<div class="page-btn next" on:click={nextPage}>
				<Icon
					name="ARROW_RIGHT"
					color="#161B45"
					size={12}
				/>
			</div>
		{/if}
		<div class="total-pages">{translate('von')} {pages}</div>
	</div>
{/if}

<style type="text/scss" lang="scss">
	.pagination {
		display: flex;
		align-items: center;
	}

	.disabled {
		.page-btn {
			opacity: .6;
			pointer-events: none;
			cursor: stop;
		}
	}

	.page-btn {
		width: 33px;
		height: 33px;
		font-weight: 600;
		display: flex;
		justify-content: center;
		align-items: center;
		user-select: none;

		&.curr {
			position: relative;
			input {
				width: 100%;
				height: 100%;
				display: block;
				position: absolute;
				top: 0;
				left: 0;
				text-align: center;
				color: #ffffff;
				background-color: var(--c-primary);
				border: none;
				border-radius: 0px;
				appearance: textfield;
				&::-webkit-outer-spin-button,
				&::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			}
		}

		&.prev,
		&.next {
			cursor: pointer;
			&:hover {
				opacity: .5;
			}
		}

		&.prev {
			margin-right: 6px;
		}

		&.next {
			margin-left: 6px;
		}
	}

	.total-pages {
		margin-left: 9px;
		font-weight: 600;
		color: var(--c-primary);
	}
</style>
